import game from './apiModule/game'
export default {
  game
}
